import { gql } from '@apollo/client';

export const PARSERS_DATA = gql`
  query parsers {
    parsers {
      id
      name
      type
      logCount
      logs
    }
  }
`;

export const REQUEST_CUSTOM_PARSER = gql`
  mutation requestCustomParser($id: ID!, $comments: String!) {
    requestCustomParser(id: $id, comments: $comments)
  }
`;

export const REVERT_CUSTOM_PARSER = gql`
  mutation revertParser($id: ID!) {
    revertParser(id: $id)
  }
`;
